import React from 'react';
import { motion } from 'framer-motion';
import { FileTextIcon, ZapIcon, MapPinIcon, BookOpenIcon, GraduationCapIcon, ShieldCheckIcon, LockIcon, CreditCardIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
const chips = [{
  icon: FileTextIcon,
  label: '100% PDF'
}, {
  icon: ZapIcon,
  label: 'Acceso en 5 min'
}, {
  icon: MapPinIcon,
  label: 'Para Argentina'
}, {
  icon: BookOpenIcon,
  label: '12 Tomos'
}, {
  icon: GraduationCapIcon,
  label: 'Universitarios'
}];
const trust = [{
  icon: ShieldCheckIcon,
  label: 'Garantía 7 días'
}, {
  icon: LockIcon,
  label: 'Pago seguro'
}, {
  icon: CreditCardIcon,
  label: 'Mercado Pago'
}, {
  icon: ZapIcon,
  label: 'Acceso inmediato'
}];
export function Hero() {
  return <header className="bg-radial-glow relative overflow-hidden" data-id="element-83" data-mp="nbyid36p5jef">
      <div className="mx-auto max-w-4xl px-5 text-center sm:pt-16 pb-[5px] pt-[13px]" data-id="element-84" data-mp="3d2lapfhgtb2a">
        <motion.p initial={{
        opacity: 0,
        y: -8
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5
      }} className="font-extrabold uppercase tracking-[0.25em] text-[#5FE39A] text-[10px]" data-id="element-85" data-mp="3825zouknofnh">
          🏆 SIGMA SMART™
        </motion.p>

        

        <span className="sm:text-[30px] font-[700] font-[Cinzel,_serif] text-[#E9C25F] text-[30px]" data-id="element-86" data-mp="399b9bibx13tc">Tu cuatrimestre resuelto desde hoy</span><motion.h1 initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.1
      }} className="tracking-tight sm:text-5xl font-[800] text-center font-display pb-[18px] text-[#5FE39A] pt-[7px] text-[18px]" data-id="element-87" data-mp="3e7l6fyh7aehl">
          MegaPack Universitario Elite ™

          <br data-id="element-88" data-mp="2qlofgaaufvkx" />
          
        </motion.h1>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.7,
        delay: 0.2
      }} className="relative mx-auto w-full max-w-md pb-[0px]" data-id="element-89" data-mp="2viewp0ydwx7x">
          <div className="absolute inset-0 -z-10 mx-auto h-64 w-64 translate-y-6 rounded-full bg-verde/25 blur-3xl" data-id="element-90" data-mp="2lmv0edfwrwin" />
          <img src="https://cdn.magicpatterns.com/uploads/khUDGjfiux2oHZLVx83Ar4/ChatGPT_Image_28_jul_2026,_18_56_40.png" alt="MegaPack Universitario Elite — 12 tomos y 5 bonos en formato digital" className="animate-floaty mx-auto max-w-full rounded-2xl w-[250px] h-[250px]" data-id="element-91" data-mp="nbbdazp8id5t" />
        </motion.div>

        

        <motion.p initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.5,
        delay: 0.05
      }} className="mt-3 text-xs font-semibold uppercase tracking-[0.18em] pt-[5px] text-[#828385]" data-id="element-92" data-mp="1b0njdqp9m53w">
          El sistema N°1 para aprobar sin recursar en Argentina
        </motion.p><div className="mt-9" data-id="element-93" data-mp="114kjyslsskkn">
          <CTAButton href="https://megapack-universitario-elite.impultienda.ar/checkout" data-id="element-94" data-mp="x1w8ed5p8zjz">
            Quiero mi MegaPack ahora
          </CTAButton>
          <motion.h2 initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          duration: 0.6,
          delay: 0.3
        }} className="mx-auto max-w-2xl font-bold text-verde-soft sm:text-xl text-[16px] pt-[12px]" data-id="element-95" data-mp="3lquf1phvu95l">
          Método de Estudio + Retención + Organización + Manejo de Ansiedad
          <br data-id="element-96" data-mp="269hbq2txd128" />
          
        </motion.h2><p className="mx-auto mt-4 max-w-2xl text-white/70 sm:text-lg text-[14px] pt-[15px]" data-id="element-97" data-mp="268g282sk4mmm">
            Todo lo que necesitás para estudiar con método, retener de verdad y rendir sin bloqueos.
            Sin improvisar. Sin perder otro año de carrera.
          </p>
          <div className="mt-7 flex flex-wrap justify-center gap-2.5 pt-[7px]" data-id="element-98" data-mp="2ky41yzl3bd88">
            {chips.map(({
            icon: Icon,
            label
          }) => <span key={label} className="inline-flex items-center gap-1.5 rounded-full border border-white/10 bg-white/5 px-3.5 py-1.5 text-xs font-semibold text-white/80" data-id="element-99" data-mp="2oyebgm83clru">
                <Icon className="h-3.5 w-3.5 text-verde-soft" data-id="element-100" data-mp="uo0v85gg70rp" />
                {label}
              </span>)}
          </div>
          <p className="mt-4 text-sm font-semibold text-white/50 pt-[7px] pb-[6px]" data-id="element-101" data-mp="znn98h43ol1k">
            12 Tomos · 5 Bonos · 100+ páginas — Todo resuelto.
          </p>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-xs font-medium text-white/50 mt-[10px] mb-[10px]" data-id="element-102" data-mp="3vh5jg58rl46o">
          {trust.map(({
          icon: Icon,
          label
        }) => <span key={label} className="inline-flex items-center gap-1.5" data-id="element-103" data-mp="9b8npjdz0z9o">
              <Icon className="h-4 w-4 text-gold" data-id="element-104" data-mp="3hr2663rv4ktd" />
              {label}
            </span>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 8
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.05
      }} className="inline-flex items-center gap-2 rounded-full border border-gold/40 bg-gold/10 px-4 py-1.5 text-xs font-bold uppercase tracking-wide text-gold pt-[4px] pb-[4px] mt-[18px] mb-[18px]" data-id="element-105" data-mp="3csile6p09f2l">
          🔥 Oferta de lanzamiento — El precio cierra pronto · No vuelve
        </motion.div>
      </div>
    </header>;
}